import React, {useState} from "react";
import {Dialog} from "primereact/dialog";
import {Checkbox} from "primereact/checkbox";
import {XCalendar} from "@michalrakus/x-react-web-lib/XCalendar";
import {XButton} from "@michalrakus/x-react-web-lib/XButton";
import {Utils} from "../../Utils";
import {ReportPreruseniaSluzbyRequest} from "../../common/noclaharen-api";
import {XUtils} from "@michalrakus/x-react-web-lib/XUtils";
import {XUtilsCommon} from "@michalrakus/x-react-web-lib/XUtilsCommon";

export const ReportPreruseniaSluzbyDialog = (props: {
    dialogOpened: boolean;
    onHideDialog: () => void;
}) => {

    const [datumOd, setDatumOd] = useState<Date | null>(null);
    const [datumDo, setDatumDo] = useState<Date | null>(null);
    const [kratkodobePrerusenia, setKratkodobePrerusenia] = useState<boolean>(true);
    const [dlhodobePrerusenia, setDlhodobePrerusenia] = useState<boolean>(true);
    const [trvalePrerusenia, setTrvalePrerusenia] = useState<boolean>(true);

    // bez tejto metody by pri opetovnom otvoreni dialogu ponechal povodne hodnoty
    const onShow = () => {
        const datumDo: Date = Utils.todayNoclaharen();
        let datumOd: Date = XUtilsCommon.dateAddMonths(datumDo, -1)!;
        datumOd = XUtilsCommon.dateAddDays(datumOd, 1)!;
        setDatumOd(datumOd);
        setDatumDo(datumDo);
        setKratkodobePrerusenia(true);
        setDlhodobePrerusenia(true);
        setTrvalePrerusenia(true);
    }

    const onOk = async () => {
        if (!kratkodobePrerusenia && !dlhodobePrerusenia && !trvalePrerusenia) {
            alert("Vyberte aspoň jeden typ prerušenia.");
            return;
        }

        const reportPreruseniaSluzbyRequest: ReportPreruseniaSluzbyRequest = {
            dateFrom: datumOd,
            dateTo: datumDo,
            kratkodobePrerusenia: kratkodobePrerusenia,
            dlhodobePrerusenia: dlhodobePrerusenia,
            trvalePrerusenia: trvalePrerusenia
        };
        XUtils.openExcelReport('noclaharen-prerusenia', reportPreruseniaSluzbyRequest);

        props.onHideDialog();
    }

    // poznamka: renderovanie vnutornych komponentov Dialogu sa zavola az po otvoreni dialogu
    return (
        <Dialog visible={props.dialogOpened} onShow={onShow} onHide={props.onHideDialog}>
            <div className="field grid">
                <label className="col-fixed" style={{width:'7rem'}}>Dátum od</label>
                <XCalendar value={datumOd} onChange={(value: Date | null) => setDatumOd(value)}/>
            </div>
            <div className="field grid">
                <label className="col-fixed" style={{width:'7rem'}}>Dátum do</label>
                <XCalendar value={datumDo} onChange={(value: Date | null) => setDatumDo(value)}/>
            </div>
            <div className="field grid">
                <label className="col-fixed" style={{width:'12rem'}} htmlFor="kratkodobePrerusenia">Krátkodobé prerušenia</label>
                <Checkbox inputId="kratkodobePrerusenia" checked={kratkodobePrerusenia} onChange={(e) => setKratkodobePrerusenia(e.checked ?? false)}/>
            </div>
            <div className="field grid">
                <label className="col-fixed" style={{width:'12rem'}} htmlFor="dlhodobePrerusenia">Dlhodobé prerušenia</label>
                <Checkbox inputId="dlhodobePrerusenia" checked={dlhodobePrerusenia} onChange={(e) => setDlhodobePrerusenia(e.checked ?? false)}/>
            </div>
            <div className="field grid">
                <label className="col-fixed" style={{width:'12rem'}} htmlFor="trvalePrerusenia">Trvalé prerušenia</label>
                <Checkbox inputId="trvalePrerusenia" checked={trvalePrerusenia} onChange={(e) => setTrvalePrerusenia(e.checked ?? false)}/>
            </div>
            <div className="flex justify-content-center">
                <XButton label="Ok" onClick={onOk}/>
            </div>
        </Dialog>
    );
}
